import type { ITheme } from "@fluentui/react/lib/Styling";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { ActionControlSemanticColors } from "@1js/acui-common";
import { getActionControlSemanticColorsWithTheme } from "@1js/acui-common";

import {
  getRibbonTopBarContainerWidth,
  getRibbonTopBarStylingConstants,
} from "../../ribbonStylingConstants";
import { customTokens, isNextStyleEnabled } from "@1js/acui-theme";

export interface RibbonTopBarClassNames {
  root: string;
}

export function getRibbonTopBarWrapperStylesNext() {
  return (
    isNextStyleEnabled() && {
      backgroundColor: customTokens.colorNeutralBackground3,
    }
  );
}

export const getRibbonTopBarClassNames = memoizeFunction(
  (
    theme: ITheme,
    height?: number,
    hasPeripheralControls?: boolean
  ): RibbonTopBarClassNames => {
    const actionControlSemanticColors: ActionControlSemanticColors =
      getActionControlSemanticColorsWithTheme(theme);
    const styles = {
      root: {
        backgroundColor: actionControlSemanticColors.defaultBackgroundColor,
        whiteSpace: "nowrap",
        height: height || getRibbonTopBarStylingConstants().topBarHeight,
        width: getRibbonTopBarContainerWidth(),
        ...getRibbonTopBarWrapperStylesNext(),
      },
    };

    const withPeripheralButtonsStyles = {
      root: {
        display: "flex",
        justifyContent: "space-between",
      },
    };
    return hasPeripheralControls
      ? mergeStyleSets(withPeripheralButtonsStyles, styles)
      : mergeStyleSets(styles);
  }
);
